import { defineComponent as r, openBlock as t, createBlock as l, unref as i, mergeProps as c, withCtx as p, createElementVNode as a } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconMinusInCircleFilled",
  __name: "IconMinusInCircleFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (d, e) => (t(), l(i(s), c(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        a("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25m-4 9a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
